exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "form.form-registration[data-v-523074b0]{margin-top:40px}form.form-registration .has-error[data-v-523074b0]{margin-bottom:15px}form.form-registration .form-group-nm[data-v-523074b0]{margin-bottom:0}@media (min-width:1200px){form.form-registration input[type=checkbox][data-v-523074b0]{margin-top:-3px}}", ""]);

// exports
